{
  "currencySign": {
    "euro": "€",
    "dollar": "$"
  },
  "step_3_title": "Übersicht",
  "network_address_placeholder": "Erlaubte Netzwerke (i.e., 10.0.0.4/16)",
  "labels": {
    "date_picker_tooltip": "Bitte wählen Sie einen Cluster und geben Sie den Zeitpunkt in {{utc}} ein",
    "date_picker_tooltip_of_selected_cluster": "Geben Sie den Zeitpunkt in {{utc}} ein. Der älteste mögliche Zeitpnutk ist {{date}} ({{utc}})",
    "compute_plan": "Leistungsplan",
    "storage_plan": "Speicherplan",
    "cores": "Kerne",
    "type": "Typ",
    "memory": "RAM",
    "per_day": "pro Tag",
    "per_month": "pro Monat",
    "size": "Größe",
    "per_instance": "Pro Instanz",
    "replicas": "Replikate",
    "total": "Total",
    "name": "Name",
    "description": "Beschreibung",
    "project": "Projekt",
    "allow_all_connection": "Alle Verbindungen erlauben",
    "recommended": "Empfohlen",
    "choose_compute_plan": "Wählen Sie einen Leistungsplan aus",
    "choose_storage_plan": "Wählen Sie einen Speicherplan aus",
    "select_project": "Wählen Sie ein Projekt aus",
    "cancel": "Abbrechen",
    "select_organization_from_left": "Wählen Sie eine Organisation aus",
    "select_project_from_left": "Wählen Sie ein Projekt aus",
    "organizations": "Organisationen",
    "departments": "Abteilungen",
    "projects": "Projekte",
    "clusters": "Cluster",
    "services": "Services",
    "org_does_not_have_projects": "Diese Organisation hat noch keine Projekte",
    "project_does_not_have_clusters": "Dieses Projekt hat noch keine Cluster",
    "organization": "Organisation",
    "private": "Privat",
    "warn_inaccessible_instance": "Falls Sie kein Netzwerk erlauben werden Sie keinen Zugriff auf den Cluster haben",
    "unexpected_error": "Unerwarteter Fehler",
    "select_project_modal_title": "Wählen Sie ein Projekt aus",
    "this_cluster_belongs_to": "Dieser Cluster gehört zu",
    "clone_settings": "Einstellungen übernehmen",
    "backup_datetime": "Backup Zeitpunkt auswählen",
    "source_cluster_belongs_to": "Ursprungscluster gehört zu",
    "select_cluster": "Cluster auswählen",
    "select_cluster_modal_title": "Wählen Sie einen Cluster aus",
    "select_backup_cluster_modal_title": "Backup Cluster auswählen",
    "org_does_not_have_suitable_clusters": "Sie haben momentan keine Organsitionen mit geeigneten Clustern",
    "project_does_not_have_suitable_clusters": "Sie haben momentan keine Projekte mit geeigneten Clustern",
    "local_time": "Ihre Ortszeit",
    "support_plan": "Support-Plan",
    "choose_support_plans": "Wählen Sie einen Support-Plan",
    "dynamic_allocation": {
      "cpu_number": "Anzahl der CPUs",
      "memory_gbs": "Arbeitsspeicher Kapazität",
      "storage_gbs": "Massenspeicher Kapazität",
      "storage_class": "Speicherklasse",
      "per_unit": "pro Einheit",
      "per_gb": "pro Gb.",
      "tbs": "{{count}} TBs",
      "use_tbs": "TBs verwenden"
    },
    "mode": {
      "switch_to_plan": "In den Assistenten Modus wechseln",
      "switch_to_dynamic": "In den Erweiterten Modus wechseln"
    },
    "configure_maintenance_windows": {
      "weekday": "Wartungstag auswählen",
      "every_day": "Täglich",
      "start_time": "Startzeit",
      "end_time": "Endzeit",
      "max_limit": "Maximale Anzahl an Wartungsfenstern erreicht",
      "local_time_hint": "Die geplante Wartung ist <b>{{weekday}}</b> von <b>{{startTime}}</b> bis <b>{{endTime}}</b> ({{utcLocal}}, Ihre lokale Zeit)",
      "actions": {
        "add": "Wartungsfenster hinzufügen",
        "remove": "Wartungsfenster entfernen"
      }
    }
  },
  "templates": {
    "create_cluster": "{{name}} erstellen",
    "add_to_project": "In {{project}} erstellen",
    "create_cluster_from_backup": "{{name}} aus Backup erstellen",
    "select_entity": "{{name}} auswählen"
  },
  "parameters": {
    "configure_backup": "Backupkonfiguration",
    "clone_acl": "Access Control List (pg_hba)",
    "clone_parameters": "PostgreSQL Parameter",
    "clone_logical_backup_configuration": "Logische Backupkonfiguration",
    "clone_continuous_backup_configuration": "Kontinuierliche Backupkonfiguration",
    "configure_maintenance_windows": "Wartungsfenster konfigurieren"
  },
  "specs": {
    "price_with_sign": "{{amount|currency}}",
    "memory_in_gb": "{{count}} GB",
    "size_in_gb": "{{count}} GB",
    "cores_spec": "{{count}} Kerne",
    "cores_spec_plural": "{{count}} Kerne",
    "none": "Keine"
  },
  "buttons": {
    "previous": "Zurück",
    "next": "Weiter",
    "create": "Erstellen",
    "reset_backup_config": "Reset to source cluster's configuration"
  },
  "validation": {
    "name": {
      "empty": "Geben Sie einen Namen ein",
      "duplicate_name": "Dieser Name ist bereits vergeben",
      "min_length": "Der Name darf nicht kürzer als {{minLength}} Zeichen sein",
      "max_length": "Der Name darf nicht länger als {{maxLength}} Zeichen sein",
      "invalid": "Der Name muss mit einem Buchstaben beginnen und mit einem Buchstaben oder einer Ziffer enden. Er darf Leerzeichen, Punkte und Bindestriche enthalten."
    },
    "description": {
      "required": "Geben Sie eine Beschreibung ein",
      "max": "Die Beschreibung darf nicht länger als 200 Zeichen sein"
    },
    "project": {
      "required": "Wählen Sie ein Projekt aus"
    },
    "allowedSourceRanges": {
      "not_valid": "Ungültige IPv4 Netzwerk Adresse (gültiges Format: 10.0.0.0/16)"
    },
    "allowedSourceRangesInput": {
      "not_valid": "Ungültige IPv4 Netzwerk Adresse (gültiges Format: 10.0.0.0/16)"
    },
    "backupTimestamp": {
      "empty": "Wählen Sie einen Backup Zeitpunkt",
      "after_max_date": "Backup Zeitpunkt darf nicht nach {{maxDate}} ({{utc}}) sein",
      "before_min_date": "Backup Zeitpunkt darf nicht vor {{minDate}} ({{utc}}) sein",
      "invalid_date": "Ungültiges Datumsformat",
      "invalid_date_label": "Ungültiges Datum"
    },
    "backupCluster": {
      "empty": "Wählen Sie einen Ursprungsclutser"
    },
    "backupName": {
      "insufficient_storage_space": "Die Sicherung ist größer als der verfügbare Speicherplatz"
    },
    "network_mask_hint": "Dieses Feld erlaubt mehrere Eingaben. Bitte drücken Sie die Eingabetaste um eines hinzuzufügen.",
    "storageGbs": {
      "empty": "Geben Sie eine Massenspeicher Kapazität ein",
      "min_capacity": "Der Massenspeicher muss mindestens {{capacity}} betragen",
      "max_capacity": "Der Massenspeicher darf maximal {{capacity}} betragen"
    },
    "memoryGbs": {
      "empty": "Geben Sie eine Arbeitsspeicher Kapazität ein",
      "min_capacity": "Der Arbeitspeicher muss mindestens {{capacity}} betragen",
      "max_capacity": "Der Arbeitspeicher darf maximal {{capacity}} betragen"
    },
    "cpuUnits": {
      "empty": "Geben Sie die Anzahl der CPUs ein",
      "min_capacity": "Anzahl der CPUs muss mindestens {{amount}} betragen",
      "max_capacity": "Anzahl der CPUs darf maximal {{amount}} betragen",
      "decimal_places": "Anzahl der CPUs darf maximal 3 Dezimalstellen beinhalten"
    },
    "maintenance_windows": {
      "max_length": "Wartungsfenster dürfen nur {{maxLength}} Einträge enthalten",
      "maintenance_windows_daily_exclusive": "Ein tägliches Wartungsfenster kann nicht mit anderen Wartungsfenstern kombiniert werden. Bitte entfernen Sie die zusätzlichen Einträge."
    }
  },
  "warnings": {
    "cluster_creation_disabled": "Die Cluster-Erstellung wurde temporär blockiert. Wir bitten um Entschuldigung für die Unannehmlichkeiten.",
    "insufficient_resources": "Der Server hat nicht genügend Ressourcen um diesen Cluster zu erzeugen. Bitte kontaktieren Sie Ihren Superuser um mehr Ressourcen zu allokieren, oder versuchen sie es mit einem kleinerem Plan erneut.",
    "choose_compute_plan": "Ihr Cluster entspricht keinem existierenden Leistungsplan. Bitte wählen Sie einen neuen.",
    "choose_storage_plan": "Ihr Cluster entspricht keinem existierenden Speicherplan. Bitte wählen Sie einen neuen."
  }
}
